<script>
import  {prize_pools, places} from "@/consts/prize"
import PrizeCard from "@/components/2025/Prizes/PrizeCard.vue";
export default {
  name: "PrizePool",
  components: {PrizeCard},
  props: ["game"],
  data(){
    return{
      prizePools: {...prize_pools},
      places: {...places},
    }
  },
  computed:{
    currentPrizePool(){
      return this.prizePools[this.game]
    }
  }
}
</script>

<template>
  <div class="prize-pool-wrapper w-100">
    <div v-if="currentPrizePool.has_phases" class="w-100">
      <div class="w-100 mb-2 w-100">
        <h6 class="phase-title mb-1">./QUALIFICATION</h6>
        <PrizeCard place="first" :prize-amount="currentPrizePool.quali.first"></PrizeCard>
        <PrizeCard place="second" :prize-amount="currentPrizePool.quali.second"></PrizeCard>
        <PrizeCard place="third" :prize-amount="currentPrizePool.quali.third"></PrizeCard>
      </div>
      <div class="total-wrapper w-100 mt-1">
        <div class="total-container py-1 px-2 pr-4 d-flex justify-content-between align-items-center">
          <h5 class="total-label text-right m-0">Total</h5>
          <h5 class="total-prize text-uppercase m-0">{{currentPrizePool.quali.total}}</h5>
        </div>
      </div>
      <div class="w-100 mt-3">
        <h6 class="phase-title mb-1">./FINALS</h6>
        <PrizeCard place="first" :prize-amount="currentPrizePool.finals.first"></PrizeCard>
        <PrizeCard place="second" :prize-amount="currentPrizePool.finals.second"></PrizeCard>
        <PrizeCard place="third" :prize-amount="currentPrizePool.finals.third"></PrizeCard>
      </div>
      <div class="total-wrapper w-100 mt-1">
        <div class="total-container py-1 px-2 pr-4 d-flex justify-content-between align-items-center">
          <h5 class="total-label text-right m-0">Total</h5>
          <h5 class="total-prize text-uppercase m-0">{{currentPrizePool.finals.total}}</h5>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="w-100">
        <PrizeCard place="first" :prize-amount="currentPrizePool.first"></PrizeCard>
        <PrizeCard place="second" :prize-amount="currentPrizePool.second"></PrizeCard>
        <PrizeCard place="third" :prize-amount="currentPrizePool.third"></PrizeCard>
        <PrizeCard place="fourth" :prize-amount="currentPrizePool.fourth" v-if="currentPrizePool.fourth"></PrizeCard>
        <PrizeCard place="fifth" :prize-amount="currentPrizePool.fifth" v-if="currentPrizePool.fifth"></PrizeCard>
        <PrizeCard place="sixth" :prize-amount="currentPrizePool.sixth" v-if="currentPrizePool.sixth"></PrizeCard>
      </div>
      <div class="total-wrapper w-100 mt-1">
        <div class="total-container py-1 px-2 pr-4 d-flex justify-content-between align-items-center">
          <h5 class="total-label text-right m-0">Total</h5>
          <h5 class="total-prize text-uppercase m-0">{{currentPrizePool.total}}</h5>
        </div>
      </div>
    </div>

  </div>
</template>

<style scoped>
.total-wrapper {
  background: #121212;
  clip-path: polygon(0 0, 100% 0, 100% calc(100% - 10px), calc(100% - 10px) 100%, 0 100%);
  border-radius: 0 0 14px 0;
}
.total-container {
  background: rgba(250, 70, 36, 0.15);
  background: linear-gradient(90deg, rgba(77, 237, 15, 1) 0%,rgba(77, 237, 15, 0.5) 1%, rgba(77, 237, 15, 0.25) 15%, rgba(77, 237, 15, 0) 100%);
}
.total-label, .total-prize{
  font-family: "sqwaredsemi_bold";
  color: rgba(255,255,255,0.8) !important;
  font-style: italic;
}
.phase-title{
  color: white;
  font-family: "sqwaredbold";
}
</style>